export const IMDB_LABEL = 'Imdb';
export const LINKEDIN_LABEL = 'LinkedIn';
export const STUDIO_SYSTEM_LABEL = 'StudioSystem';
export const STUDIO_SYSTEM_LOCALE_LABEL = 'Studio System';

export const IMDB_ID_LABEL = 'imdbProfileId';
export const LINKEDIN_ID_LABEL = 'linkedInProfileId';

export const IMDB_HOST = 'www.imdb.com';
export const IMDB_ME_HOST = 'imdb.me';
export const IMDB_PRO_HOST = 'pro.imdb.com';
export const LINKEDIN_HOST = 'linkedin.com';
export const STUDIO_SYSTEM_HOST = 'studiosystem.com';

export const LINKEDIN_REGEX = /^[A-Za-z]+\./;
export const ROOT_DOMAIN_REGEX = /([a-z0-9-]+\.[a-z]{2,})$/i;
export const URL_REGEX = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

export const DOMAIN_ERROR = 'DomainError';
export const PROFILE_CONFLICT_ERROR = 'ProfileConflictError';
export const UNPARSABLE_ID_ERROR = 'UnparsableError';